/**
 * Next legal hop for the staff "推进步骤" affordance (SRS 附录 E.2).
 * Never jumps ASSIGNED → COMPLETED — that is illegal.
 */
export function suggestNextStepStatus(
  from: string,
): "IN_PROGRESS" | "COMPLETED" | null {
  switch (from) {
    case "NOT_STARTED":
    case "ASSIGNED":
    case "WAITING_CLIENT":
    case "WAITING_LOGISTICS":
    case "WAITING_DOCUMENT":
    case "REOPENED":
    case "REJECTED":
      return "IN_PROGRESS";
    case "IN_PROGRESS":
    case "PENDING_APPROVAL":
      return "COMPLETED";
    default:
      return null;
  }
}
